/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const availabilityRangeUpdateRequestSchema = z.object({
  endDate: z.iso.date().nullish(),
  fridayDuration: z.int().nullish(),
  mondayDuration: z.int().nullish(),
  name: z.string().nullish(),
  observanceRule: z.enum(['NONE', 'NEXT_WORKING_DAY']).nullish(),
  preserveHistoricalData: z.boolean().nullish(),
  priority: z.string().nullish(),
  saturdayDuration: z.int().nullish(),
  startDate: z.iso.date().nullish(),
  sundayDuration: z.int().nullish(),
  thursdayDuration: z.int().nullish(),
  tuesdayDuration: z.int().nullish(),
  wednesdayDuration: z.int().nullish(),
});
